import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/player.svg';
var RATIOS = {
  '1/1': '',
  '4/3': 'ri-4_3',
  '16/9': 'ri-16_9'
};
export default {
  name: 'MdmVideo',
  props: {
    image: {
      type: String,
      required: true
    },
    video: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'white'
    },
    withBackground: {
      type: Boolean,
      default: false
    },
    play: {
      type: Boolean,
      default: false
    },
    ratio: {
      type: String,
      default: '16/9'
    },
    muted: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      playing: this.play
    };
  },
  computed: {
    currentVideo: function currentVideo() {
      return "".concat(this.video, "?rel=0&amp;showinfo=0;0&autoplay=1");
    },
    youtube: function youtube() {
      // regex for youtube videos
      // return this.video.includes('youtube');
      return this.video !== 'url-video-embed';
    }
  },
  methods: {
    playVideo: function playVideo() {
      if (this.youtube) {
        this.playing = true;
      }
    },
    stopVideo: function stopVideo() {
      if (this.youtube) {
        this.playing = false;
      }
    },
    builderRatio: function builderRatio(value) {
      return RATIOS[value];
    }
  }
};